import type { ReactNode } from "react";
import { Link } from "react-router-dom";

interface SectionTitleProps {
  title: string;
  subtitle?: string;
  moreTo?: string;
  moreLabel?: string;
  icon?: string;
  children?: ReactNode;
}

export default function SectionTitle({
  title,
  subtitle,
  moreTo,
  moreLabel = "查看更多",
  icon,
  children,
}: SectionTitleProps) {
  return (
    <div className="mb-5 flex items-end justify-between gap-4">
      <div className="flex items-center gap-3">
        <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-primary-500 text-lg text-background-50">
          <i className={icon || "ri-hashtag"} />
        </span>
        <div>
          <h2 className="font-heading text-lg font-extrabold text-foreground-950 md:text-xl">{title}</h2>
          {subtitle && <p className="mt-0.5 text-xs text-foreground-500 md:text-sm">{subtitle}</p>}
        </div>
      </div>
      <div className="flex shrink-0 items-center gap-3">
        {children}
        {moreTo && (
          <Link
            to={moreTo}
            className="hidden items-center gap-0.5 whitespace-nowrap text-sm font-medium text-foreground-600 transition-colors hover:text-primary-600 sm:flex"
          >
            {moreLabel}
            <i className="ri-arrow-right-s-line text-base" />
          </Link>
        )}
      </div>
    </div>
  );
}